import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: 'status/:reference',
    loadComponent: () => import('./pages/payment-status/payment-status').then((m) => m.PaymentStatus),
  },
];
